const FILE_CONSTANTS = {
  Zip: { title: 'Zip', format: 'application/zip, application/x-zip-compressed' },
  PDF: { title: 'PDF', format: 'application/pdf' },
  CSV: { title: 'CSV', format: 'text/csv' },
  XLSX: {
    title: 'XLSX',
    format: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
  XLS: { title: 'XLS', format: 'application/vnd.ms-excel' },
  PNG: { title: 'PNG/JPEG', format: 'image/png,image/jpeg,image/jpg' },
  GIF: { title: 'GIF', format: 'image/gif' },
  BMP: { title: 'BMP', format: 'image/bmp' },
  TIFF: { title: 'TIFF', format: 'image/tiff' },
  TXT: { title: 'TXT', format: 'text/plain' },
  DOC: { title: 'DOC', format: 'application/msword' },
  DOCX: {
    title: 'DOCX/GDoc',
    format:
      'application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  PPT: { title: 'PPT', format: 'application/vnd.ms-powerpoint' },
  PPTX: {
    title: 'PPTX',
    format: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  SVG: { title: 'SVG', format: 'image/svg+xml' },
  FILE_FORMAT: {
    jpeg: 'image/jpeg',
    png: 'image/png',
    jpg: 'image/jpg',
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    zip: 'application/zip',
  },
}
export default FILE_CONSTANTS
